import React from 'react'
import * as R from 'remeda'

import { type ColumnInfo, compact, fiveSegments } from '~/utils'

import { type OverlapColumnKey as ColumnKey } from '../utils'

const widthMap: Record<ColumnKey, string> = {
  brand1Name: '2em',
  brand1Segments: '6em',
  ...R.mapToObj(['all', ...fiveSegments] as const, (fiveSegment) => [
    fiveSegment,
    '6em',
  ]),
}

const columnKeys: ColumnKey[] = compact([
  'brand1Name',
  'brand1Segments',
  'all',
  ...fiveSegments,
])

export const useOverlapTableColumns = (): ColumnInfo<ColumnKey>[] =>
  React.useMemo(
    () => columnKeys.map((key) => ({ key, width: widthMap[key] })),
    [],
  )
